import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';


@Injectable({
  providedIn: 'root'
})
export class TokenService implements HttpInterceptor {

  constructor() {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const reqClone = req.clone({
      setHeaders: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('idToken')}`
      }
    });

    return next.handle(reqClone).pipe(catchError(this.httpERROR));
  }

  httpERROR(error: HttpErrorResponse, message: any): Observable<any> {
    // 401 errors are most likely going to be because we have an expired token that we need to refresh.
    console.log(error);
    return throwError(error);
  }
}
